import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard'; // Import PrivateRoute
import PrivateRoute from '../private/PrivateRoute';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Protect the Dashboard route with PrivateRoute */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
